/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Body2Inputs */

const en_to_typescript_body2 = /** @type {(inputs: To_Typescript_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For an API you are integrating against, paste the fattest response you can find, ideally one where optional fields are populated and arrays are non empty. Then treat the output as a first draft: rename the root, widen fields you know can be absent, and replace inferred literals with the domain types you actually want. It saves the mechanical typing, not the thinking.`)
};

const ko_to_typescript_body2 = /** @type {(inputs: To_Typescript_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연동하려는 API라면 찾을 수 있는 가장 풍성한 응답을 붙여넣으세요. 선택적 필드가 채워져 있고 배열이 비어 있지 않은 것이 이상적입니다. 그다음 출력을 초안으로 다루세요. 루트 이름을 바꾸고, 없을 수 있다고 아는 필드를 넓히고, 추론된 리터럴을 실제로 원하는 도메인 타입으로 바꾸는 것입니다. 기계적인 타이핑을 줄여주지 사고를 줄여주지는 않습니다.`)
};

const ja_to_typescript_body2 = /** @type {(inputs: To_Typescript_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携しようとしている API なら、見つけられる中で最も内容の詰まったレスポンスを貼り付けてください。任意フィールドが埋まっていて配列が空でないものが理想です。そのうえで出力は下書きとして扱ってください。ルート名を変え、欠けうると分かっているフィールドを広げ、推論されたリテラルを実際に使いたいドメイン型に置き換えます。機械的なタイピングは省けますが、考えることは省けません。`)
};

/**
* | output |
* | --- |
* | "For an API you are integrating against, paste the fattest response you can find, ideally one where optional fields are populated and arrays are non empty. Th..." |
*
* @param {To_Typescript_Body2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_body2 = /** @type {((inputs?: To_Typescript_Body2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Body2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_body2(inputs)
	if (locale === "ko") return ko_to_typescript_body2(inputs)
	return ja_to_typescript_body2(inputs)
});